import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6543ce07"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "apply-title" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "发票申请", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow-right-svg" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "请选择发票抬头", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow-right-svg" }, null, -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "invoice-info"
}
const _hoisted_8 = { class: "info-list van-hairline--top" }
const _hoisted_9 = { class: "value" }
const _hoisted_10 = { class: "info-list van-hairline--top" }
const _hoisted_11 = { class: "value" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "*仅提供电子发票", -1))

import { ref, computed, withDefaults } from 'vue'
import { useRouter } from 'vue-router'
import { ConfirmUseStorageData } from '@/types/invoice'
import { useUsermobileInfo } from '@/compositions/common'
import { invoiceNewTypeTextMap, confirmUseInvoiceStorageKey } from '@/config/invoice'


export default /*#__PURE__*/_defineComponent({
  __name: 'order-apply',
  props: {
    labelWidth: null,
    costInfoType: { type: Boolean },
    listItemJustifyContent: null,
    listItemMt: null
  },
  emits: ['invoiceInit'],
  setup(__props: any, { emit: emits }) {

const props = __props as { labelWidth?: number | string, costInfoType?: boolean, listItemJustifyContent?: string, listItemMt?: number };



const $router = useRouter()
const labelStyle = computed(() => {
  const width = props.labelWidth
  if (!width) {
    return ''
  }
  return {
    width: typeof width === 'number' ? width + 'px' : width,
  }
})
const { userMobileComputed } = useUsermobileInfo()
const confirmUseInvoiceStorageData: ConfirmUseStorageData | null = JSON.parse(
  sessionStorage.getItem(confirmUseInvoiceStorageKey)
)
const invoiceInfo = ref(
  confirmUseInvoiceStorageData?.needInvoice && confirmUseInvoiceStorageData?.invoice
    ? [
        { label: '发票抬头', value: confirmUseInvoiceStorageData?.invoice?.header },
        { label: '发票税号', value: confirmUseInvoiceStorageData?.invoice?.taxpayer_no },
        {
          label: '发票类型',
          value: invoiceNewTypeTextMap.get(confirmUseInvoiceStorageData?.invoice?.invoice_type),
        },
      ]
    : []
)
const smsMessageInfo = computed(() => {
  return [{ label: '短信通知  ', value: userMobileComputed.value }]
})

const hasInvoiceInfo = computed(() => {
  return invoiceInfo.value.length
})

function selectInvoice() {
  // sessionStorage.setItem(cacheKey, JSON.stringify(detail.value))
  $router.push({
    name: 'invoice-confirm-new',
    query: {
      canUnUseInvoice: '1',
    },
  })
}
function getListItemStyle(index: number) {
  const arr = []
  const listItemJustifyContent = props.listItemJustifyContent
  const listItemMt = props.listItemMt
  if (listItemJustifyContent) {
    arr.push(`justify-content: ${listItemJustifyContent}`)
  }
  if (listItemMt && index > 0) {
    arr.push(`margin-top: ${listItemMt}px`)
  }
  return arr.join(';')
}
if (confirmUseInvoiceStorageData) {
  emits('invoiceInit', confirmUseInvoiceStorageData)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      (_unref(hasInvoiceInfo))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "choose-again",
            onClick: selectInvoice
          }, [
            _createTextVNode(" 重新选择"),
            _hoisted_3
          ]))
        : _createCommentVNode("", true)
    ]),
    (!_unref(hasInvoiceInfo))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "cell",
          onClick: selectInvoice
        }, _hoisted_6))
      : _createCommentVNode("", true),
    (_unref(hasInvoiceInfo))
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(invoiceInfo.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                style: _normalizeStyle(getListItemStyle(index))
              }, [
                _createElementVNode("div", {
                  class: "label",
                  style: _normalizeStyle(_unref(labelStyle))
                }, _toDisplayString(item.label), 5),
                _createElementVNode("div", _hoisted_9, _toDisplayString(item.value), 1)
              ], 4))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(smsMessageInfo), (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                style: _normalizeStyle(getListItemStyle(index))
              }, [
                _createElementVNode("div", {
                  class: "label",
                  style: _normalizeStyle(_unref(labelStyle))
                }, _toDisplayString(item.label), 5),
                _createElementVNode("div", _hoisted_11, _toDisplayString(item.value), 1)
              ], 4))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_12
  ], 64))
}
}

})